export type VoiceState =
    | 'unsupported'
    | 'idle'
    | 'awaiting_permission'
    | 'recording'
    | 'stopping'
    | 'uploading'
    | 'error'
    | 'denied'
    | 'unavailable'

export type VoiceAction =
    | { type: 'REQUEST_PERMISSION' }
    | { type: 'PERMISSION_GRANTED' }
    | { type: 'PERMISSION_DENIED' }
    | { type: 'PERMISSION_UNAVAILABLE' }
    | { type: 'STOP_RECORDING' }
    | { type: 'CHUNKS_READY' }
    | { type: 'UPLOAD_SUCCESS' }
    | { type: 'UPLOAD_FAILURE'; error: string }
    | { type: 'RETRY' }
    | { type: 'RESET' }

export interface VoiceReducerState {
    state: VoiceState
    error: string | null
    elapsedSec: number
}

export function voiceReducer(
    state: VoiceReducerState,
    action: VoiceAction,
): VoiceReducerState {
    switch (action.type) {
        case 'REQUEST_PERMISSION':
            if (
                state.state === 'idle' ||
                state.state === 'error' ||
                state.state === 'denied' ||
                state.state === 'unavailable'
            ) {
                return { ...state, state: 'awaiting_permission', error: null, elapsedSec: 0 }
            }
            return state
        case 'PERMISSION_GRANTED':
            if (state.state === 'awaiting_permission') return { ...state, state: 'recording' }
            return state
        case 'PERMISSION_DENIED':
            if (state.state === 'awaiting_permission') {
                return {
                    ...state,
                    state: 'denied',
                    error: 'Microphone blocked — click the lock icon in your address bar to allow',
                }
            }
            return state
        case 'PERMISSION_UNAVAILABLE':
            if (state.state === 'awaiting_permission') {
                return { ...state, state: 'unavailable', error: 'No microphone found' }
            }
            return state
        case 'STOP_RECORDING':
            if (state.state === 'recording') return { ...state, state: 'stopping' }
            return state
        case 'CHUNKS_READY':
            if (state.state === 'stopping') return { ...state, state: 'uploading' }
            return state
        case 'UPLOAD_SUCCESS':
            if (state.state === 'uploading') return { ...state, state: 'idle', error: null }
            return state
        case 'UPLOAD_FAILURE':
            if (state.state === 'uploading') return { ...state, state: 'error', error: action.error }
            return state
        case 'RETRY':
            if (
                state.state === 'error' ||
                state.state === 'denied' ||
                state.state === 'unavailable'
            ) {
                return { ...state, state: 'awaiting_permission', error: null, elapsedSec: 0 }
            }
            return state
        case 'RESET':
            return { state: 'idle', error: null, elapsedSec: 0 }
        default:
            return state
    }
}
